import React from "react";
import { Row, Col, Breadcrumb } from "react-bootstrap";
import BasicPieChart from "../../components/Charts/PieCharts/BasicPieChart";
import PieDonutChart from "../../components/Charts/PieCharts/PieDonutChart";
import PieMonochromeChart from "../../components/Charts/PieCharts/PieMonochromeChart";

const Pie = () => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
        <h3 className="mb-0">Pie</h3>

        <Breadcrumb className="breadcrumb-page-list align-items-center mb-0 lh-1">
          <Breadcrumb.Item href="/dashboard/ecommerce">
            <div className="d-flex align-items-center text-decoration-none">
              <i className="ri-home-4-line fs-18 text-primary me-1"></i>
              <span className="text-secondary fw-medium hover">Dashboard</span>
            </div>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <span className="fw-medium">Charts</span>
          </Breadcrumb.Item>

          <Breadcrumb.Item active>
            <span className="fw-medium">Pie</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Row>
        <Col lg={6}>
          <BasicPieChart />
        </Col>

        <Col lg={6}>
          <PieDonutChart />
        </Col>

        <Col lg={6}>
          <PieMonochromeChart />
        </Col>
      </Row>
    </>
  );
};

export default Pie;
